module.exports = __webpack_public_path__ + "img/circle-dark.7bf8d19f.svg";